/* ==========================================================================
   Guide pages: pairings picker + "Add both to bag"
   Used by: sections/guide-pairings.liquid
   "Add both to bag" adds both variants in one /cart/add.js call, then opens
   the cart page. Kept separate from Turbo's ajax-submit cart flow on purpose.
   ========================================================================== */
(function () {
  'use strict';

  function initPairings(root) {
    if (root.dataset.gdReady) return;
    root.dataset.gdReady = 'true';

    var tabs = root.querySelectorAll('[data-gd-tab]');
    var panels = root.querySelectorAll('[data-gd-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-gd-tab');
        tabs.forEach(function (t) {
          t.setAttribute('aria-pressed', t === tab ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-gd-panel') !== id;
        });
      });
    });

    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add.js';

    root.querySelectorAll('[data-gd-add-pair]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var ids = btn.getAttribute('data-gd-add-pair').split(',');
        var error = btn.parentNode.querySelector('[data-gd-error]');
        var label = btn.textContent;

        btn.disabled = true;
        btn.textContent = 'Adding…';
        if (error) error.hidden = true;

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; })
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart add failed: ' + res.status);
            window.location.href = cartUrl;
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = label;
            if (error) error.hidden = false;
          });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-gd-pairings]').forEach(initPairings);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
